// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Controls_wrapper__2Zn9d","checkboxes":"Controls_checkboxes__GmNNr"};